import makeStyles from "@material-ui/core/styles/makeStyles";
import "@fontsource/montserrat";

const useStyles = makeStyles((theme) => ({
  root: { minHeight: "500px", paddingBottom: "30px", paddingTop: '60px' },
  headingOne: {
    fontSize: "28px",
    fontWeight: 600,
    fontFamily: "Montserrat",
    color: "#3e4a59",
  },
  headingTwo: {
    color: "rgba(86, 58, 150, 1)",
    fontSize: "40px",
    fontWeight: "600",
    fontFamily: "Montserrat",
  },
  upperDisplay: {
    width: "86%",
    marginTop: "25px",
    padding: "25px",
    background:
      "linear-gradient(90deg, rgba(247,243,255,1) 0%, rgba(222, 212, 245,0.8130602582830007) 100%)",
  },
  upperDisplayImage: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      marginBottom: "30px",
    },
  },
  mobileMarginForUpperDisplayGrids: {
    [theme.breakpoints.down("md")]: {
      marginBottom: "30px",
    },
  },
  headingthreeone: {
    fontSize: "14px",
    color: "#6f59a6",
    fontWeight: 600,
    fontFamily: "Montserrat",
  },
  showInMiddle: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  headingthreetwo: {
    fontSize: "16px",
    fontWeight: "bold",
    fontFamily: "Montserrat",
    color: "#838186 !important",
  },
  displaySurfaceContentBox: {
    position: "absolute",
    height: "60px",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "inherit",
    borderRadius: "6px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#277acc",
    width: "170px",
    fontFamily: "Montserrat",
    fontSize: "20px",
    fontWeight: "bold",
    [theme.breakpoints.down('md')]: {
      fontSize: "20px",
    }
  },
  lineWithDotContainer: {
    position: "relative",
  },
  lineWithDotLeft: {
    position: "absolute",
    top: "50%",
    left: 0,
    transform: "translateY(-50%)",
    width: "70px",
  },
  lineWithDotRight: {
    position: "absolute",
    top: "50%",
    right: 0,
    transform: "translateY(-50%)",
    width: "70px",
  },
  secondaryDisplayContainer: {
    marginTop: "30px",
    width: "100%",
    padding: "0 7%",
  },
  secondaryDisplay: {
    padding: "20px",
    background:
      "linear-gradient(90deg, rgba(247,243,255,1) 0%, rgba(199,207,230,0.7430322470785189) 100%)",
    borderRadius: "13px",
    height: "100%",
    position: 'relative'
  },
  personImage: {
    height: "160px",
    width: "140px",
    objectFit: "contain",
    borderRadius: "8px",
    boxShadow: theme.shadows[6],
  },
  headingfourone: {
    fontSize: "14px",
    color: "#6f59a6",
    fontWeight: 600,
    fontFamily: "Montserrat",
    textAlign: "left",
  },
  headingfourtwo: {
    fontSize: "14px",
    color: "#3e4a59",
    fontWeight: 600,
    fontFamily: "Montserrat",
    textAlign: "left",
  },
  secondaryDisplayDivider: {
    backgroundColor: "#3AC2D7",
    height: "3px !important",
  },
  underTypography: {
    fontFamily: "Montserrat",
    fontSize: "18px",
    marginTop: "10px",
    color: "#277acc",
    fontWeight: "bold",
  },
  mentorshipOverviewContainer: {
    marginTop: "30px",
    padding: "0px 9% 40px 9%",
    background:
      "linear-gradient(180deg, rgba(247,243,255,1) 0%, rgba(199,207,230,0.7430322470785189) 100%)",
    position: "relative",
  },
  sideGraphic1: {
    position: "absolute",
    bottom: 10,
    left: 60,
    height: "200px",
    transform: "scaleX(-1)",
  },
  mentorshipOverviewHeading: {
    fontFamily: "Montserrat",
    color: "#6f59a6",
    fontSize: "36px",
    fontWeight: "bold",
  },
  mentorshipOverviewSubheading: {
    fontFamily: "Montserrat",
    color: "#277acc",
    fontSize: "16px",
    fontWeight: "bold",
    marginTop: "30px",
  },
  mentorshipOverview: {
    width: "100%",
    height: "35px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    border: "2px solid rgba(0,0,0,0.2)",
    borderRadius: "4px",
    marginTop: "10px",
    backgroundColor: "#b499c7",
    color: "#fff",
    fontFamily: "Montserrat",
    fontWeight: "bold",
  },
  mentorshipOverview2: {
    width: "100%",
    height: "35px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    border: "2px solid rgba(0,0,0,0.2)",
    borderRadius: "4px",
    marginTop: "10px",
    backgroundColor: "#fff",
    color: "#fff",
    fontFamily: "Montserrat",
    fontWeight: "bold",
  },
  mentorshipOverviewTy: {
    fontFamily: "Montserrat",
    fontWeight: "bold",
    textAlign: 'center !important',
    width: '100%',
    height: '100%'
  },
  select: {
    fontSize: "16px",
    width: "100%",
    whiteSpace: "nowrap",
    textAlign: "center",
    marginTop: '8px'
  },
  sessionsSummary: {
    padding: "50px 7% 30px 7%",
  },
  sessionsSummarySurface: {
    padding: "30px 50px",
    marginTop: "30px",
    backgroundColor: "rgba(199,207,230,0.34)",
    [theme.breakpoints.down('md')]: {
      overflowX: 'scroll', 
      overflowY: 'hidden'
    }
  },
  sessionsSummarySurfaceInner: {
    [theme.breakpoints.down('md')]: {
      width: '800px'
    }
  },
  sessionsSummarySubheading: {
    fontSize: "18px",
    color: "#277acc",
    fontFamily: "Montserrat",
    fontWeight: "bold",
  },
  sessionsSummarySubheading2: {
    fontSize: "18px",
    color: "#277acc",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    position:"relative",
    display:"flex",
    justifyContent:"center",
    },
  summarySession: {
    fontSize: "18px",
    fontFamily: "Montserrat",
    color: "#6f59a6",
    textAlign: "left",
    fontWeight: 600,
  },

  sessionButton: {
    backgroundColor: "#6f59a6",
    fontFamily: "Montserrat",
    color: "white",
    fontSize: "16px",
    fontWeight: "bold",
    transition: '0.5s',
    '&:hover': {
      transform: 'translateY(-10px)', 
      backgroundColor: '#6f59a6'
    }
  },
  confirmButtonOverview: {
    backgroundColor: "#6f59a6",
    fontFamily: "Montserrat",
    color: "#fff",
    fontSize: "16px",
    fontWeight: "bold",
    marginTop: "30px",
    padding: "10px 35px",
    transition: '0.5s',
    '&:hover': {
      transform: 'translateY(-10px)', 
      backgroundColor: '#6f59a6'
    }
  },

  mentorshipDocumentsContainer: {
    // marginTop: "20px",
    padding: "0px 7% 20px 7%",
    background:
      "linear-gradient(180deg, rgba(247,243,255,1) 0%, rgb(230 230 230 / 74%) 100%)",
    position: "relative",
  },
  sideGraphic2: {
    position: "absolute",
    bottom: 30,
    right: 60,
    height: "200px",
  },
  alternativeLabel: {
    top: "50%",
  },
  completedSessionsContainer: {
    padding: "0px 7%",
  },
  uploadRoundButton: {
    height: "150px",
    width: "150px",
    borderRadius: "50%",
    backgroundColor: "#3ac2d7",
  },
  tooltip: {
    backgroundColor: "rgba(118,95,170,1)",
    padding: '5px',
    maxWidth: 'none',
    [theme.breakpoints.down('md')]:{
      display:'none',
    }
  },
  tooltipArrow: {
    backgroundColor: "rgba(118,95,170,1)",
  }, 
  sessionsSummarySubheading3: {
    fontSize: "18px",
    color: "#277acc",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    position:"relative",
    display:"flex",
    justifyContent:"end",
    position:"relative",
    right:"1.65rem"
  },
  sessionsSummarySubheading3: {
    fontSize: "18px",
    color: "#277acc",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    position:"relative",
    display:"flex",
    justifyContent:"center",
    position:"relative",
    marginTop:"2rem",
  },
  sessionsSummarySubheading4: {
    fontSize: "18px",
    color: "#277acc",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    position:"relative",
    display:"flex",
    justifyContent:"end",
    position:"relative",
    right:"1.65rem",
    marginBottom:"1.5rem"
  },
  middleButtonContainer: {
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column', 
      height: '250px'
    }
  }, 
  middleButtons: {
    [theme.breakpoints.down('md')]: {
      position: 'absolute !important', 
    }
  },
  middleButtons2: {
    [theme.breakpoints.down('md')]: {
      position: 'absolute !important', 
      transform: 'translateY(50px)'
    }
  },
}));

export default useStyles;
